import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, ButtonToolbar, Radio} from "react-bootstrap";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import Links from "../../../../utilities/linksConfig/Links";
import {
    TopButtonAction,
    TopButtonAdd,
    TopButtonCancel,
    TopButtonPointEdit,
    TopButtonSave
} from "../../../../componentsTopsa/buttons/TopButtons";
import KartyService from "../../../klienciConfig/karty/KartyService";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import initialData from "../../../../utilities/initialData/initialData";
import acc from "accounting";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import BiletyService from "../biletyApi/BiletyService";
import KlienciService from "../../../klienciConfig/KlienciService";
import InfoTooltip from "../../../../componentsTopsa/infoTooptip/InfoTooltip";
import KartaDanegoKlienta from "../../../klienciConfig/klienci/externalComponents/KartaDanegoKlienta";
import LSService from "../../../../utilities/localStorageService/LSService";
import KartyForm from "../../../klienciConfig/karty/components/KartyForm";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import Select from 'react-select'
import ZnizkiService from "../znizki/ZnizkiService";
import LogowanieService from "../../../logowanie/LogowanieService";

import KonfiguracjaService from "../../../administracja/konfiguracja/KonfiguracjaService";
import FirmyService from "../../../klienciConfig/firmy/FirmyService";
import FirmyForm from "../../../klienciConfig/firmy/components/FirmyForm";
import download from 'downloadjs'
import Validator from "../../../../utilities/Validator";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import moment from "moment";

export default class DodajBiletMiesiecznyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validatorMessages: [],
            trasy: [],
            karty: [],
            cena: 0,
            karta: null,
            rok: new Date().toJSON().substr(0, 4),
            miesiac: null,
            uwagi: '',
            statusy: [
                {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#333'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#333'}
            ],
            status: null,
            klient: null,
            czyPrzekierowacDoStronyKlienta: false,
            czyPrzekierowacDoKart: false,
            kartaDoEdycji: null,
            forma: null,
            formy: [],
            dodanoBilet: false,
            nowoDodany: {},

            czyFaktura: 1,
            firmaDoFaktury: null,

            pokazFormularzDodawaniaEdycjiFirmy: false,
            czyWydrukowanoParagon: false,
            czyPrzycisnietoWydrukujParagon: false,
            setLoaderWydruk: false,

            wlasnaCena: '',

            czyJestToPrzedluzenie: false,

            nipOpcjonalny: '',
            nipError: false
        };
        this.onClickDodaj = this.onClickDodaj.bind(this)
        this.onChangeKarta = this.onChangeKarta.bind(this)
        this.onChangeRok = this.onChangeRok.bind(this)
        this.onChangeMiesiac = this.onChangeMiesiac.bind(this)
        this.onChangeUwagi = this.onChangeUwagi.bind(this)
        this.onClickEditKarta = this.onClickEditKarta.bind(this)
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
        this.onClickZapiszEdycjeKarty = this.onClickZapiszEdycjeKarty.bind(this)
        this.onChangeFirmaDoFaktury = this.onChangeFirmaDoFaktury.bind(this)
        this.onClickZapiszFirme = this.onClickZapiszFirme.bind(this)
        this.onWydrukujParagon = this.onWydrukujParagon.bind(this)
    }

    componentDidMount() {

        // init trasy
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))

        // init formy
        BiletyService.pobierzFormyPlatnosci().then(function (response) {
            this.setState({formy: response.data, forma: response.data[0]})
        }.bind(this))

        //init miesiac - jesli powyzej dwudziestego dnia obecnego miesiaca to przechodzi na nastepny miesiac

        let miesiac;


        if (parseInt(new Date().toJSON().substr(8, 2)) >= 20) {
            let nastmiesiac = parseInt(new Date().toJSON().substr(5, 2)) + 1
            if (nastmiesiac > 12) {
                miesiac = initialData.returnArrayMiesiace()[0]
                this.setState({rok: (parseInt(new Date().toJSON().substr(0, 4)) + 1).toString()})
                document.getElementById('inputRok').value = parseInt(new Date().toJSON().substr(0, 4)) + 1
            } else {
                miesiac = initialData.returnArrayMiesiace().find(m => m.value == nastmiesiac)

            }
            if (Boolean(miesiac)) {
                this.setState({miesiac: miesiac})
            }
        } else {
            miesiac = initialData.returnArrayMiesiace().find(m => m.value == new Date().toJSON().substr(5, 2))
            if (Boolean(miesiac)) {
                this.setState({miesiac: miesiac})
            }
        }


        // init status
        this.setState({status: this.state.statusy[1]})

        if (Boolean(this.props.match.params.nrKarty)) {
            KartyService.getKartyByNrKarty(this.props.match.params.nrKarty).then(function (response) {
                if (response.status < 300) {
                    if (response.data.content.length === 0) {
                        alert('Nie udało się odnaleźć rekordów spełniających wymagania nrKarty = ' + this.props.match.params.nrKarty)
                    } else if (response.data.content.length > 1) {
                        alert('Znaleziono więcej niż jeden rekord posiadający nrKarty = ' + this.props.match.params.nrKarty + ' - proszę wyszukać ręcznie')
                    } else if (response.data.content.length === 1) {

                        let nastmiesiac = parseInt(new Date().toJSON().substr(5, 2)) + 1
                        let data
                        let miesiac
                        let okr = '01'
                        if (response.data.okres == 'P2') okr = '16'
                        if (nastmiesiac > 12) {
                            miesiac = initialData.returnArrayMiesiace()[0]
                            data = (parseInt(new Date().toJSON().substr(0, 4)) + 1) + '-'   + miesiac.value + '-' + okr
                            document.getElementById('inputRok').value = parseInt(new Date().toJSON().substr(0, 4)) + 1
                        } else {
                            miesiac = initialData.returnArrayMiesiace().find(m => m.value == nastmiesiac)
                            data = (parseInt(new Date().toJSON().substr(0, 4))) + '-'   + miesiac.value + '-' + okr
                        }

                        this.pobierzCenyBiletowMiesiecznych(response.data.content[0], data)
                        this.setState({
                            karta: response.data.content[0],
                            rok: (nastmiesiac > 12) ? (parseInt(new Date().toJSON().substr(0, 4)) + 1) : new Date().toJSON().substr(0, 4),
                            miesiac: miesiac,
                            czyPrzekierowacDoStronyKlienta: false,
                            czyPrzekierowacDoKart: false,
                        })

                    }
                } else {
                    alert('Nie udało się odnaleźć rekordów spełniających wymagania nrKarty = ' + this.props.match.params.nrKarty)
                }

            }.bind(this))
        } else if (Boolean(LSService.pobierzDaneKartyDoDodaniaMies())) {
            KartyService.getKarta(LSService.pobierzDaneKartyDoDodaniaMies().idKa).then(function (response) {

                if (Boolean(LSService.pobierzDaneKartyDoDodaniaMies())) {

                    let przekierowanieDoKart = Boolean(LSService.pobierzDaneKartyDoDodaniaMies().przekierowacDoKart)

                    let nastmiesiac = parseInt(new Date().toJSON().substr(5, 2))

                    if (parseInt(new Date().toJSON().substr(8, 2)) >= 15) {
                        nastmiesiac = nastmiesiac + 1;
                    }

                    let data
                    let miesiac
                    let okr = '01'
                    if (response.data.okres == 'P2') okr = '16'
                    if (nastmiesiac > 12) {
                        miesiac = initialData.returnArrayMiesiace()[0]
                        data = (parseInt(new Date().toJSON().substr(0, 4)) + 1) + '-'  + miesiac.value + '-' + okr
                        document.getElementById('inputRok').value = parseInt(new Date().toJSON().substr(0, 4)) + 1
                        this.setState({rok: (parseInt(new Date().toJSON().substr(0, 4)) + 1).toString()})
                    } else {
                        miesiac = initialData.returnArrayMiesiace().find(m => m.value == nastmiesiac)
                        data = (parseInt(new Date().toJSON().substr(0, 4))) + '-'  + miesiac.value + '-' + okr
                    }

                    this.pobierzCenyBiletowMiesiecznych(response.data, data)
                    this.setState({
                        karta: response.data,
                        rok: (nastmiesiac > 12) ? (parseInt(new Date().toJSON().substr(0, 4)) + 1) : new Date().toJSON().substr(0, 4),
                        miesiac: miesiac,
                        czyPrzekierowacDoStronyKlienta: !przekierowanieDoKart,
                        czyPrzekierowacDoKart: przekierowanieDoKart,
                        czyJestToPrzedluzenie: true
                    })
                    LSService.usunDaneKartyDoDodaniaMies()
                }

            }.bind(this))
        }
        this.pobierzKoloryStatusowBiletow()
    }


    pobierzKoloryStatusowBiletow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                let statusyarr = this.state.statusy
                for (let i = 0; i < statusyarr.length; i++) {
                    let statuskolor = arr.find(p => p.pozycja == statusyarr[i].label)
                    if (Boolean(statuskolor)) {
                        statusyarr[i].kolor = statuskolor.wartosc
                    }
                }

                this.setState({statusy: statusyarr})

            }

        }.bind(this))
    }


    onChangeKarta(e) {
        this.setState({karta: e})
        if (e !== null) {
            if (Boolean(this.state.miesiac) && this.state.rok.length === 4) {

                let msc = this.state.miesiac.value
                if (this.state.miesiac.value.length === 1) {
                    msc = '0' + (this.state.miesiac.value).toString()
                }
                let okr = '01'
                if (e.okres == 'P2') okr = '16'

                let data = this.state.rok + '-' + msc + '-' + okr
                this.pobierzCenyBiletowMiesiecznych(e, data)
            }
        }

        if (e !== null) {
            KlienciService.getKlient(e.idKl).then(function (response) {
                this.setState({klient: response.data})
            }.bind(this))
        }
    }

    onChangeRok(e) {
        this.setState({
            rok: e.target.value
        })

        if (e.target.value >= new Date().toJSON().substr(0, 4) && e.target.value < 3000) {
            if (Boolean(this.state.miesiac) && Boolean(this.state.karta)) {

                let msc = this.state.miesiac.value
                if (this.state.miesiac.value.length === 1) {
                    msc = '0' + (this.state.miesiac.value).toString()
                }
                let okr = '01'
                if (this.state.karta.okres == 'P2') okr = '16'

                let data = e.target.value + '-' + msc + '-' + okr
                this.pobierzCenyBiletowMiesiecznych(this.state.karta, data)
            }
        }
    }

    onChangeMiesiac(e) {
        this.setState({miesiac: e})
        if (e !== null) {
            if (Boolean(this.state.karta) && this.state.rok.length === 4) {

                let msc = e.value
                if (e.value.length === 1) {
                    msc = '0' + (e.value).toString()
                }
                let okr = '01'
                if (this.state.karta.okres == 'P2') okr = '16'

                let data = this.state.rok + '-' + msc + '-' + okr
                this.pobierzCenyBiletowMiesiecznych(this.state.karta, data)
                this.setState({})
            }
        }
    }

    onChangeUwagi(e) {
        if (e.target.value.length <= 200) {
            this.setState({uwagi: e.target.value})
        } else {
            document.getElementById('inputUwagi').value = this.state.uwagi
        }

    }

    dodajDoValidatorMessages(mess) {
        let arr = this.state.validatorMessages
        arr.push(mess)
        this.setState({validatorMessages: arr})
    }

    onClickDodaj() {

        this.setState({
            validatorMessages: [],
            dodanoBilet: false,
            nowoDodany: null,
            czyPrzycisnietoWydrukujParagon: false
        })
        this.state.validatorMessages = []
        let poprawne = true;

        if (!Boolean(this.state.karta)) {
            this.dodajDoValidatorMessages('Nie wybrano karty')
            poprawne = false
        } else {
            if (!Boolean(this.state.karta.nrKarty)) {
                this.dodajDoValidatorMessages('Karta nie posiada numeru! Należy najpierw uzupełnić numer karty.')
                poprawne = false
            }

            if (Boolean(this.state.miesiac)) {
                let miesiac = this.state.miesiac.value
                if (miesiac.length === 1) {
                    miesiac = '0' + miesiac
                }
                let czyObecnyMiesiac = (new Date().toJSON().substr(5, 2) == miesiac)

                if (this.state.karta.okres === 'P1' && new Date().toJSON().substr(8, 2) > 14 && czyObecnyMiesiac) {
                    this.dodajDoValidatorMessages('Kartę z biletem na pierwszą połowę miesiąca można doładować tylko do 14 dnia tego miesiąca')
                    poprawne = false
                }
            }

            if (this.state.karta.rodz === 'ZSPEC') {

                if (!Boolean(this.state.wlasnaCena)) {
                    this.dodajDoValidatorMessages('Nie podano ceny dla biletu ze zniżką specjalną!')
                    poprawne = false
                }
                if (!Validator.validateIntOrDouble(this.state.wlasnaCena)) {
                    this.dodajDoValidatorMessages('Podano nieprawidłową cenę dla biletu ze zniżką specjalną!')
                    poprawne = false
                }

            }

        }

        if (this.state.rok < new Date().toJSON().substr(0, 4) || this.state.rok > 3000) {
            this.dodajDoValidatorMessages('Nie podano prawidłowego roku')
            poprawne = false
        }
        if (!Boolean(this.state.miesiac)) {
            this.dodajDoValidatorMessages('Nie wybrano miesiąca')
            poprawne = false
        }
        if (!Boolean(this.state.cena)) {
            this.dodajDoValidatorMessages('Cena jest zerowa - należy sprawdzić datę ważności cennika')
            poprawne = false
        }

        if (this.state.czyFaktura === 1) {
            if (this.state.nipError) {
                this.dodajDoValidatorMessages('Wybrano fakturę imienną i wprowadzono NIP który jest niepoprawny - proszę poprawić NIP bądź go usunąć')
                poprawne = false
            }
        }

        if (this.state.czyFaktura === 2) {
            if (!Boolean(this.state.firmaDoFaktury)) {
                this.dodajDoValidatorMessages('Wybrano fakturę VAT - Firma musi zostać uzupełniona')
                poprawne = false
            }
        }


        if (poprawne) {

            let obj = {
                "cena": (this.state.karta.rodz === 'ZSPEC') ? parseFloat(this.state.wlasnaCena.replace(',', '.')).toFixed(2) : this.state.cena,
                "idKa": this.state.karta,
                "miesiac": this.state.miesiac.value,
                "rok": this.state.rok,
                "statBil": this.state.status.value,
                "uwagi": this.state.uwagi,
                "formaPlatn": (this.state.status.value > 0) ? this.state.forma.formaPlatn : null,
                "idUz": LogowanieService.pobierzZalogowanego().idUz,
                "sprzedazMiejsce": "BIURO",
                "idFi": (this.state.czyFaktura === 2) ? (this.state.firmaDoFaktury) ? this.state.firmaDoFaktury.idFi : null : null,
                "nipParagon": (this.state.czyFaktura === 1) ? this.state.nipOpcjonalny : null
            }


            BiletyService.addBiletMiesieczny(obj).then(function (response) {
                if (response.status < 300) {

                    this.setState({
                        dodanoBilet: true,
                        nowoDodany: response.data
                    })

                }
            }.bind(this))


        }

    }


    pobierzCenyBiletowMiesiecznych(karta, data) {

        let obj = {
            "data": moment(data).format('YYYY-MM-DD'),
            "idMiDo": karta.idMiDo,
            "idMiOd": karta.idMiOd,
            "idTr": karta.idTr,
            "kierunek": karta.kierunek,
            "okres": karta.okres
        }

        ZnizkiService.getWszytskieZnizkiMiesieczne(obj).then(function (response) {
            if (response.data.length > 0) {
                this.setState({cena: response.data.find(z => z.rodz === karta.rodz).cena})
            }
        }.bind(this))
    }

    renderKarta(option) {
        return (
            <div>
                <span className={'label label-ebus-primary'} title={'Numr karty'}>{option.nrKarty}</span>
                <span style={{marginLeft: '5px', marginRight: '10px'}}>
                    {option.nazKl + ' ' + option.imieKl}
                </span>
                <span className={'label label-ebus-default'} title={'Odcinek trasy'}>
                    {option.nazMiOd} <i className={'fa fa-long-arrow-right'}></i> {option.nazMiDo}
                </span>
            </div>
        )
    }

    onClickEditKarta() {
        this.setState({kartaDoEdycji: this.state.karta})
    }

    zamknijFormularz() {
        this.setState({kartaDoEdycji: null})
    }

    onClickZapiszEdycjeKarty(obj) {

        KartyService.editKarta(obj.idKa, obj).then(function (response) {

            let nastmiesiac = parseInt(new Date().toJSON().substr(5, 2)) + 1
            let data
            let miesiac
            let okr = '01'
            if (obj.okres == 'P2') okr = '16'
            if (nastmiesiac > 12) {
                miesiac = initialData.returnArrayMiesiace()[0]
                data = (parseInt(new Date().toJSON().substr(0, 4)) + 1) + '-' + miesiac.value + '-' + okr
                document.getElementById('inputRok').value = parseInt(new Date().toJSON().substr(0, 4)) + 1
            } else {
                miesiac = initialData.returnArrayMiesiace().find(m => m.value == nastmiesiac)
                data = (parseInt(new Date().toJSON().substr(0, 4))) + '-' + miesiac.value + '-' + okr
            }

            if (response) {
                if (response.status < 300) {
                    this.pobierzCenyBiletowMiesiecznych(obj, data)
                    this.setState({karta: obj, kartaDoEdycji: null})

                }
            }

        }.bind(this))
    }

    szukajKarty(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return KartyService.szukajKart(input).then(function (response) {
            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    info: item.imieKl + ' ' + item.nazKl + ' ' + item.nazMiOd + ' ' + item.nazMiDo
                }
            })
            return {options: arr}
        }.bind(this))
    }


    renderStatusBiletu(option) {
        return <div style={{fontWeight: 'bold', color: option.kolor}}><i className={option.ikona}
                                                                         style={{marginRight: '5px'}}></i> {option.label}
        </div>

    }

    getCompanies(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return FirmyService.szukajFirmePoNipieAlboPoNazwie(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.nip + ' ' + item.nazwa,
                }
            })
            return {options: arr}
        }.bind(this))
    }

    onChangeFirmaDoFaktury(e) {
        this.setState({
            firmaDoFaktury: e
        })
    }

    renderFirmaOption(option) {
        return (<div><span className={'label label-ebus-primary'} title={'NIP'}>{option.nip}</span> {option.nazwa}
            {option.idNabywcy ?
                <span style={{color: 'grey', fontSize: '12px', marginLeft: '15px'}}><i
                    className={'fa fa-info-circle'}></i> Tylko odbiorca!</span> : ''}
        </div>)
    }

    onClickZapiszFirme(obj, czyEdycja) {
        if (czyEdycja) {
            FirmyService.editFirma(this.state.firmaDoFaktury.idFi, obj).then(function (response) {

                let obiekt = this.state.firmaDoFaktury
                obiekt['nazwa'] = obj.nazwa
                obiekt['kodPocztowy'] = obj.kodPocztowy
                obiekt['regon'] = obj.regon
                obiekt['miejscowosc'] = obj.miejscowosc
                obiekt['nrLokalu'] = obj.nrLokalu
                obiekt['nrNieruchomosci'] = obj.nrNieruchomosci
                obiekt['ulica'] = obj.ulica
                obiekt['wojewodztwo'] = obj.wojewodztwo
                obiekt['informacje'] = obj.nip + ' ' + obj.nazwa

                this.setState({
                    firmaDoFaktury: obiekt,
                    pokazFormularzDodawaniaEdycjiFirmy: false
                })

            }.bind(this))
        } else {
            FirmyService.addFirma(obj).then(function (response) {
                if (response) {
                    if (response.data) {
                        this.setState({
                            firmaDoFaktury: Object.assign(response.data, {informacje: response.data.nip + ' ' + response.data.nazwa}),
                            pokazFormularzDodawaniaEdycjiFirmy: false
                        })
                    }
                }
            }.bind(this))

        }
    }

    onWydrukujParagon() {
        this.setState({czyPrzycisnietoWydrukujParagon: true, setLoaderWydruk: true})

        if (this.state.nowoDodany.idBm && LogowanieService.pobierzZalogowanego()) {
            BiletyService.wydrukujParagonPoZakupieMiesiecznego(LogowanieService.pobierzZalogowanego().idUz, this.state.nowoDodany.idBm).then(function (response) {
                this.setState({setLoaderWydruk: false})
                if (response.status < 300) {
                    this.setState({czyWydrukowanoParagon: true})
                } else {

                    this.setState({czyWydrukowanoParagon: false})
                }
            }.bind(this)).catch(function (err) {
                this.setState({czyWydrukowanoParagon: false, setLoaderWydruk: false})
            }.bind(this))
        }

    }

    onClickZobaczPobierzFaktureZaBilet(idBm) {
        BiletyService.pobierzLubPokazFaktureZaBiletMiesieczny(idBm, true).then(function (response) {
            const content = response.headers['content-type'];
            download(response.data, 'Bilet-msc-' + idBm, content)
        }.bind(this)).catch(err => {
            alert('Błąd - nie można pobrać faktury')
            console.log(err)
        })
    }

    onChangeWlasnaCena(e) {
        this.setState({wlasnaCena: e.target.value})
    }

    onChangeNipOpcjonalny = ({target: {value}}) => {

        this.setState({nipError: false})
        if (value.length > 0) {
            if (!Validator.validateNIP(value)) {
                this.setState({nipError: true})
            }
        }


        this.setState({nipOpcjonalny: value})

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'},
                                    {addressUrl: '/konfiguracja/zarzadzanie-biletami', text: 'Zarządzanie biletami'},
                                    {
                                        addressUrl: '/konfiguracja/zarzadzanie-biletami/bilety-miesieczne',
                                        text: 'Bilety miesięczne'
                                    },
                                    {
                                        addressUrl: '/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny',
                                        text: 'Dodaj bilet'
                                    }
                                ]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        {
                            (Boolean(this.state.dodanoBilet)) ?
                                Boolean(this.state.nowoDodany) ?
                                    <Col xs={12}>
                                        <h1>
                                            <i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> Pomyślnie
                                            dodano bilet miesięczny
                                            <div style={{marginLeft: '45px', marginTop: '15px'}}>

                                                {
                                                    (this.state.czyPrzycisnietoWydrukujParagon) ?
                                                        (this.state.setLoaderWydruk) ?
                                                            <div id={'simple-small-loader'} style={{width: '300px'}}>
                                                                <i className={'fa fa-spinner fa-spin'}></i>
                                                            </div>
                                                            :
                                                            (this.state.czyWydrukowanoParagon) ?
                                                                <span><i className={'fa fa-check'}
                                                                         style={{color: 'forestgreen'}}></i> Pomyślnie wydrukowano paragon</span>
                                                                :
                                                                <span><i className={'fa fa-times'}
                                                                         style={{color: 'firebrick'}}></i> Wystąpił błąd podczas próby druku paragonu</span>
                                                        :
                                                        <TopButtonAction text={'Wydrukuj paragon'} btnSize={'lg'}
                                                                         btnColor={'info'}
                                                                         iconType={'fa fa-file-text-o'}
                                                                         onClick={this.onWydrukujParagon}
                                                        />
                                                }

                                                <div style={{marginTop: '15px'}}>
                                                    <small>
                                                        <div>
                                                            Poniżej znajduje się podgląd faktury VAT - paragonu do
                                                            wydruku
                                                        </div>
                                                        <div style={{marginTop: '10px'}}>
                                                            <a style={{display: 'inline-block', marginLeft: '5px'}}>
                                                                <TopButtonAction iconType={'fa fa-download'}
                                                                                 onClick={() => {
                                                                                     this.onClickZobaczPobierzFaktureZaBilet(this.state.nowoDodany.idBm)
                                                                                 }}
                                                                                 btnColor={'info'}
                                                                                 text={'Pobierz fakturę'}/>
                                                            </a>
                                                        </div>
                                                        <div style={{marginTop: '30px'}}>
                                                            <TopButtonAction iconType={'fa fa-plus'}
                                                                             text={'Kliknij aby dodać kolejny bilet'}
                                                                             btnColor={'success'}
                                                                             onClick={() => this.setState({
                                                                                 dodanoBilet: false,
                                                                                 nowoDodany: null,
                                                                                 daneDoFaktury: null,
                                                                                 daneKonfig: null,
                                                                                 czyFaktura: 1,
                                                                                 firmaDoFaktury: null,
                                                                                 pokazFormularzDodawaniaEdycjiFirmy: false,
                                                                                 czyPrzycisnietoWydrukujParagon: false,
                                                                                 karta: null
                                                                             })}
                                                            />
                                                        </div>
                                                    </small>
                                                </div>
                                            </div>
                                        </h1>
                                    </Col>
                                    :
                                    <Col xs={12}>
                                        <h1>
                                            <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Wystąpił błąd
                                            podczas dodawania biletu
                                            miesięcznego
                                            <div style={{marginLeft: '45px', marginTop: '15px'}}>
                                                <small>
                                                    <div>
                                                        Wystąpił następujący błąd:
                                                    </div>
                                                    <div style={{marginTop: '30px'}}>
                                                        <TopButtonAction iconType={'fa fa-retweet'}
                                                                         text={'Kliknij aby ponowić próbę'}
                                                                         btnColor={'warning'}
                                                                         onClick={() => this.setState({
                                                                             dodanoBilet: false,
                                                                             nowoDodany: null
                                                                         })}
                                                        />
                                                    </div>
                                                </small>
                                            </div>
                                        </h1>
                                    </Col>
                                :
                                <Col sm={12}>
                                    <div style={{marginTop: '15px'}}>
                                        <fieldset>
                                            <div
                                                className={'fieldset-label'}> {(this.state.czyJestToPrzedluzenie) ? "Przedłuż bilet miesięczny na karcie" : "Nowy bilet miesięczny"}</div>
                                            <Form horizontal={true}>
                                                <FormGroup>
                                                    <Col xs={4}>
                                                        <ControlLabel>
                                                            Karta <span className={'req'}>*</span> <InfoTooltip
                                                            label={' '}
                                                            text={'Można szukać po: imie, nazwisko, miejscowość od, miejscowość do'}/>
                                                        </ControlLabel>

                                                        <Select.Async value={this.state.karta}
                                                                      onChange={this.onChangeKarta} valueKey="nrKarty"
                                                                      labelKey="nazImieKl"
                                                                      loadOptions={this.szukajKarty}
                                                                      backspaceRemoves={true}
                                                                      placeholder={'Szukaj po nazwisku i imieniu bądź po nr karty'}
                                                                      valueRenderer={this.renderKarta}
                                                                      optionRenderer={this.renderKarta}
                                                                      ignoreAccents={false}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                {
                                                    Boolean(this.state.karta) ?
                                                        <FormGroup>
                                                            {Boolean(this.state.kartaDoEdycji) ?
                                                                <Col xs={12}>
                                                                    <KartyForm trasy={this.state.trasy}
                                                                               handleClickAnuluj={this.zamknijFormularz}
                                                                               handleClickZapisz={this.onClickZapiszEdycjeKarty}
                                                                               edytowana={this.state.kartaDoEdycji}
                                                                               czyEdycjaZWidokuDodawania={true}
                                                                    />
                                                                </Col>
                                                                :
                                                                <Col xs={12} lg={6}>
                                                                    <KartaDanegoKlienta klient={this.state.klient}
                                                                                        karta={this.state.karta}
                                                                                        pokazEdycje={true}
                                                                                        onEditKarta={this.onClickEditKarta}
                                                                    />
                                                                </Col>
                                                            }
                                                        </FormGroup>
                                                        :
                                                        ''
                                                }
                                                <FormGroup>
                                                    <Col xs={1}>
                                                        <ControlLabel>
                                                            Rok <span className={'req'}>*</span>
                                                        </ControlLabel>
                                                        <FormControl defaultValue={new Date().toJSON().substr(0, 4)}
                                                                     type={'number'}
                                                                     onChange={this.onChangeRok} id={'inputRok'}
                                                                     disabled={Boolean(this.state.kartaDoEdycji)}/>
                                                    </Col>
                                                    <Col xs={2}>
                                                        <ControlLabel>
                                                            Miesiąc <span className={'req'}>*</span>
                                                        </ControlLabel>
                                                        <TopSelect onChange={this.onChangeMiesiac}
                                                                   value={this.state.miesiac}
                                                                   options={initialData.returnArrayMiesiace()}
                                                                   clearable={false}
                                                                   disabled={Boolean(this.state.kartaDoEdycji)}/>
                                                    </Col>
                                                    <Col xs={3}>
                                                        <ControlLabel>
                                                            {
                                                                Boolean(this.state.karta) ?
                                                                    this.state.karta.rodz === 'ZSPEC' ?
                                                                        <span style={{color: 'dodgerblue'}}><i
                                                                            className={'fa fa-info-circle'}></i> Zniżka specjalna - można ręcznie uzupełnić cenę</span>
                                                                        :
                                                                        ' '
                                                                    :
                                                                    ' '
                                                            }
                                                        </ControlLabel>
                                                        <div>
                                                            {
                                                                Boolean(this.state.karta) ?
                                                                    this.state.karta.rodz === 'ZSPEC' ?
                                                                        <div>
                                                                            <FormControl type={'number'}
                                                                                         style={{
                                                                                             width: '200px',
                                                                                             display: 'inline-block'
                                                                                         }}
                                                                                         onChange={(e) => this.onChangeWlasnaCena(e)}
                                                                                         id={'inputWlasnaCena'}/>
                                                                            <span style={{
                                                                                color: 'grey',
                                                                                fontSize: '12px',
                                                                                fontStyle: 'italic',
                                                                                marginLeft: '15px'
                                                                            }}>Normalna cena: {acc.formatMoney(this.state.cena)}</span>
                                                                        </div>
                                                                        :
                                                                        <div style={{
                                                                            fontWeight: 'bold',
                                                                            lineHeight: '34px'
                                                                        }}>Cena: {acc.formatMoney(this.state.cena)}</div>
                                                                    :
                                                                    <div style={{
                                                                        fontWeight: 'bold',
                                                                        lineHeight: '34px'
                                                                    }}>Cena: {acc.formatMoney(this.state.cena)}</div>
                                                            }
                                                        </div>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Col xs={2}>
                                                        <ControlLabel>
                                                            Status <span className={'req'}>*</span>
                                                        </ControlLabel>
                                                        <TopSelect disabled={true
                                                            //Boolean(this.state.kartaDoEdycji)
                                                        }
                                                                   onChange={(e) => {
                                                                       this.setState({status: e})
                                                                   }}
                                                                   value={this.state.status}
                                                                   options={this.state.statusy}
                                                                   clearable={false}
                                                                   valueRenderer={this.renderStatusBiletu}
                                                                   optionRenderer={this.renderStatusBiletu}

                                                        />
                                                    </Col>
                                                    <Col xs={2}>
                                                        <ControlLabel>
                                                            Forma płatności <span className={'req'}>*</span>
                                                        </ControlLabel>
                                                        <TopSelect
                                                            disabled={Boolean(this.state.kartaDoEdycji) || Boolean(this.state.status) ? this.state.status.value < 0 : false}
                                                            onChange={(e) => {
                                                                this.setState({forma: e})
                                                            }}
                                                            value={this.state.forma}
                                                            options={this.state.formy}
                                                            clearable={false}
                                                            valueKey={'formaPlatn'}
                                                            labelKey={'nazwa'}
                                                        />
                                                    </Col>
                                                    <Col xs={4}>
                                                        <ControlLabel>
                                                            Uwagi
                                                        </ControlLabel>
                                                        <FormControl disabled={!Boolean(this.state.karta)}
                                                                     onChange={this.onChangeUwagi} id={'inputUwagi'}
                                                        />
                                                    </Col>
                                                    <Col xs={3}>
                                                        <div className={'add-label-margin'}></div>
                                                        <ButtonToolbar>
                                                            <TopButtonCancel onClick={() => {
                                                                this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety-miesieczne')
                                                            }}/>
                                                            <TopButtonSave onClick={this.onClickDodaj}
                                                                           text={'Zapisz bilet'}/>
                                                        </ButtonToolbar>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Col xs={12}><ControlLabel>Czy wydrukować
                                                        fakturę?</ControlLabel></Col>
                                                    <Col xs={2}>
                                                        <Radio name="radioGroupDodajMsc" inline
                                                               checked={(this.state.czyFaktura === 1)} onClick={() => {
                                                            this.setState({czyFaktura: 1})
                                                        }}>
                                                            Faktura imienna
                                                        </Radio>
                                                        {' '}
                                                        <Radio name="radioGroupDodajMsc" inline
                                                               checked={(this.state.czyFaktura === 2)} onClick={() => {
                                                            this.setState({czyFaktura: 2})
                                                        }}>
                                                            Faktura VAT
                                                        </Radio>
                                                    </Col>
                                                    {
                                                        (this.state.czyFaktura === 1) &&
                                                        <Col xs={12}>
                                                            <div style={{width: '300px'}}>
                                                                <ControlLabel>
                                                                    <span>NIP (opcjonalny) </span>
                                                                    {
                                                                        (this.state.nipOpcjonalny.length > 0 && this.state.nipError) &&
                                                                        <TopAlertUwaga inline={true}
                                                                                       text='Niepoprawny NIP'/>
                                                                    }
                                                                </ControlLabel>
                                                                <FormControl
                                                                    type={'text'}
                                                                    onChange={this.onChangeNipOpcjonalny}
                                                                    id={'InputNipOpcjonalny'}
                                                                /></div>
                                                        </Col>
                                                    }
                                                    {
                                                        (Boolean(this.state.czyFaktura === 2) && !Boolean(this.state.pokazFormularzDodawaniaEdycjiFirmy)) ?
                                                            <Col xs={4}>
                                                                <Select.Async value={this.state.firmaDoFaktury}
                                                                              onChange={this.onChangeFirmaDoFaktury}
                                                                              valueKey="idFi"
                                                                              labelKey="informacje"
                                                                              loadOptions={this.getCompanies}
                                                                              clearable={false}
                                                                              backspaceRemoves={true}
                                                                              placeholder={'Wyszukaj firmę po NIP lub po nazwie'}

                                                                              valueRenderer={(option) => this.renderFirmaOption(option)}
                                                                              optionRenderer={(option) => this.renderFirmaOption(option)}
                                                                              ignoreAccents={false}
                                                                              noResultsText={<div>Brak
                                                                                  wyników <TopButtonAdd
                                                                                      onClick={() => this.setState({pokazFormularzDodawaniaEdycjiFirmy: true})}
                                                                                      text={'Dodaj nową firmę'}
                                                                                      buttonSize={'small'}/></div>}
                                                                />
                                                            </Col>
                                                            :
                                                            ''
                                                    }
                                                </FormGroup>
                                                <FormGroup>
                                                    {
                                                        Boolean(this.state.pokazFormularzDodawaniaEdycjiFirmy) ?
                                                            <Col xs={12}>
                                                                <FirmyForm
                                                                    edytowanaFirma={this.state.firmaDoFaktury}
                                                                    czyMoznaEdytowacNip={!(Boolean(this.state.firmaDoFaktury))}
                                                                    handleClickAnuluj={() => {
                                                                        this.setState({pokazFormularzDodawaniaEdycjiFirmy: false})
                                                                    }}
                                                                    handleClickZapisz={this.onClickZapiszFirme}
                                                                />
                                                            </Col>
                                                            :

                                                            <Col xs={8}>
                                                                {
                                                                    (Boolean(this.state.firmaDoFaktury) && this.state.czyFaktura == 2) ?
                                                                        <div>
                                                                            <div className={'thumbnail'}
                                                                                 style={{padding: '15px'}}>
                                                                                <h4 style={{marginBottom: '5px'}}>Firma,
                                                                                    na którą zostanie wystawiona
                                                                                    faktura:</h4>
                                                                                <div>
                                                                                    <Row>
                                                                                        <Col xs={4}>
                                                                                            <h5 style={{
                                                                                                color: 'grey',
                                                                                                fontStyle: 'italic'
                                                                                            }}>Dane
                                                                                                podstawowe</h5>
                                                                                            <div>
                                                                                                <label>Nazwa:</label> {this.state.firmaDoFaktury.nazwa}
                                                                                            </div>
                                                                                            <div>
                                                                                                <label>NIP:</label> {this.state.firmaDoFaktury.nip}
                                                                                            </div>
                                                                                            {
                                                                                                Boolean(this.state.firmaDoFaktury.regon) ?
                                                                                                    <div>
                                                                                                        <label>REGON:</label> {this.state.firmaDoFaktury.regon}
                                                                                                    </div>
                                                                                                    :
                                                                                                    ''
                                                                                            }
                                                                                        </Col>
                                                                                        <Col xs={4}>
                                                                                            <h5 style={{
                                                                                                color: 'grey',
                                                                                                fontStyle: 'italic'
                                                                                            }}>Adres</h5>
                                                                                            <div>
                                                                                                {Boolean(this.state.firmaDoFaktury.ulica) ? this.state.firmaDoFaktury.ulica : ''} {Boolean(this.state.firmaDoFaktury.nrNieruchomosci) ? this.state.firmaDoFaktury.nrNieruchomosci : ''}{Boolean(this.state.firmaDoFaktury.nrLokalu) ? '/' + this.state.firmaDoFaktury.nrLokalu : ''}
                                                                                            </div>
                                                                                            <div>
                                                                                                {Boolean(this.state.firmaDoFaktury.kodPocztowy) ? this.state.firmaDoFaktury.kodPocztowy : ''} {this.state.firmaDoFaktury.miejscowosc}{Boolean(this.state.firmaDoFaktury.wojewodztwo) ? ', ' + this.state.firmaDoFaktury.wojewodztwo : ''}
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col xs={4}>
                                                                                            <TopButtonPointEdit
                                                                                                onClick={() => this.setState({pokazFormularzDodawaniaEdycjiFirmy: true})}
                                                                                                titleContent={'Edytuj dane firmy'}/>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        ''
                                                                }
                                                            </Col>
                                                    }
                                                </FormGroup>
                                                <FormGroup>
                                                    <ValidatorMessages messages={this.state.validatorMessages}/>
                                                </FormGroup>
                                            </Form>
                                        </fieldset>
                                    </div>
                                </Col>
                        }
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletMiesieczny/DodajBiletMiesiecznyContainer.js